if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_pages_MyProfile_index_js-node_modules_pnpm_mui_material_5_15_20__emotion_react_11_14_0__t-c80cee":1,"src_pages_Clients_index_js-node_modules_pnpm_mui_material_5_15_20__emotion_react_11_14_0__typ-8662b0":1,"src_pages_ContentManager_index_js-src_pages_ContentManager_components_PhotoGrid_PhotoGrid_css":1,"src_pages_ContentManager_AccommodationsManager_AccommodationsEditor_index_js-node_modules_pnp-40fa0d":1,"src_pages_ContentManager_ServicesManager_ServicesEditor_index_js-node_modules_pnpm_tippy_js_6-3ff3e9":1,"src_components_v2_Modals_BaseModal_js-src_pages_ContentManager_CountriesManager_CountriesEdit-1fb1cb":1,"src_components_v2_Modals_BaseModal_js-src_pages_ContentManager_RegionsManager_RegionsEditor_i-8860c4":1,"src_pages_ContentManager_RoomsManager_RoomsEditor_index_js-node_modules_pnpm_mui_material_5_1-5c728d":1,"src_pages_MyAgents_index_js-node_modules_pnpm_mui_material_5_15_20__emotion_react_11_14_0__ty-c4b035":1,"src_pages_Agencies_Agencies_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_ti-44ad23":1,"src_pages_MyAgency_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_css":1,"vendors-node_modules_pnpm_mui_icons-material_5_15_20__mui_material_5_15_20__emotion_react_11_-89b4c2":1,"src_pages_Clients_ClientDetails_index_js-node_modules_pnpm_mui_material_5_15_20__emotion_reac-38e948":1,"src_api_queries_client_js-src_api_queries_edge_js-src_components_ItrvlAppBar_js-common_helper-163e7d":1,"src_pages_Login_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_dist_tippy_css":1,"src_pages_Edge_Catalog_index_js-node_modules_pnpm_mui_utils_5_17_1__types_react_18_3_28_react-4a2d0d":1,"src_pages_Insights_ClusterExplorer_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tip-a332e1":1,"src_pages_Insights_ShapeMap_index_js-node_modules_pnpm_tippy_js_6_3_7_node_modules_tippy_js_d-5bef2c":1,"src_pages_ItineraryBuilder_ItineraryBuilderEntry_js-node_modules_pnpm_slick-carousel_1_8_1_jq-951b21":1,"src_pages_EditItinerary_EditItineraryEntry_js-node_modules_pnpm_mui_material_5_15_20__emotion-16da1f":1,"src_pages_PresentationEdit_index_js-common_helpers_date-fns-locale-en-US-shim_js-node_modules-807ce0":1,"src_pages_Edge_Detail_index_js-node_modules_pnpm_mui_material_5_15_20__emotion_react_11_14_0_-718daa":1,"vendors-node_modules_pnpm_video_js_7_21_7_node_modules_video_js_dist_video-js_css":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded